export const Loading = "Loading/cart-loading";
export const Success = "Success/cart-Success";
export const Error = "Error/cart-Error";

export const Update_Cart_Qty = "Update_Cart_Qty/cart-Update_Cart_Qty";
export const Remove_Cart_Item = "Remove_Cart_Item/cart-Remove_Cart_Item";
